import { useEffect } from 'react';
import { buildPrintCSS } from './buildPrintCSS';
import { LabelPrintingLayoutPreset } from './Toolbar/presets';
import { PRINT_HOST_ID, PRINT_STYLE_ID } from './print';

function getOrCreateStyleEl(): HTMLStyleElement {
  const existing = document.getElementById(
    PRINT_STYLE_ID,
  ) as HTMLStyleElement | null;

  if (existing) return existing;

  const styleEl = document.createElement('style');
  styleEl.id = PRINT_STYLE_ID;
  document.head.appendChild(styleEl);
  return styleEl;
}

function getOrCreatePrintHost(): HTMLDivElement {
  const existing = document.getElementById(
    PRINT_HOST_ID,
  ) as HTMLDivElement | null;

  if (existing) return existing;

  const host = document.createElement('div');
  host.id = PRINT_HOST_ID;
  document.body.appendChild(host);
  return host;
}

export function usePrintStyles(
  layout: LabelPrintingLayoutPreset | undefined,
): void {
  useEffect(() => {
    getOrCreateStyleEl().textContent = buildPrintCSS(layout);
  }, [layout]);

  useEffect(() => {
    getOrCreatePrintHost();

    return () => {
      document.getElementById(PRINT_STYLE_ID)?.remove();
      document.getElementById(PRINT_HOST_ID)?.remove();
    };
  }, []);
}
